import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface CounterState {
  value: number;
}

const initialState: CounterState = {
  value: 0,
};

export const counterSlice = createSlice({
  name: 'counter',
  initialState,
  reducers: {
    increment: (state) => {
      state.value += 1;
    },
    decrement: (state) => {
      state.value -= 1;
    },
    incrementByAmount: (state, action: PayloadAction<number>) => {
      state.value += action.payload;
    },
    resetCounterSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
  },
});

export const { increment, decrement, incrementByAmount, resetCounterSlice } =
  counterSlice.actions;

export default counterSlice.reducer;
